import { useState } from "react"
import { KeyedMutator } from "swr"

import {
    SUPPORT_REFER,
    SUPPORT_REFER_HELP_DESK,
} from "../../../../errors/errorMessages"
import { parseErrorAsObj } from "../../../../errors/errorProcessors"
import { snackbar } from "../../../../utils/general/generalUtils"
import { patchClientProtected } from "../../clients/clients"
import { TUsersOutput } from "../../mappers/adminPortal/activeUsersMapper"
import { RESET_USER_MFA } from "../../urls/private"

type IResetUserMfa = {
    resetUserMfa: () => Promise<void>
    isLoading: boolean
}

/**
 * Mutate relevent list users key on sucessfull submission
 * This hook exposes a fucntion for deleting a single user
 * @param {string} userName - is the congnito user name ID
 * @returns {IDeleteUser} - delete function and loading state
 */
const useResetMfa = (
    userName: string,
    fullName: string,
    mutate: KeyedMutator<TUsersOutput>
): IResetUserMfa => {
    const [isLoading, setIsLoading] = useState(false)
    const resetUserMfa = async (): Promise<void> => {
        try {
            setIsLoading(true)
            await patchClientProtected(RESET_USER_MFA(userName), null)
            snackbar(`Successfully Reset MFA for ${fullName}`, "success")
            mutate()
        } catch (err) {
            const errorObj = parseErrorAsObj(err)
            let errorMsg
            if (errorObj?.code === 403) {
                errorMsg = `${errorObj?.message}. Please ${SUPPORT_REFER_HELP_DESK}`
            } else {
                errorMsg = `Unable to Reset MFA for ${fullName}. Please try again. ${SUPPORT_REFER}`
            }
            snackbar(errorMsg, "warning")
        } finally {
            setIsLoading(false)
        }
    }

    return {
        resetUserMfa,
        isLoading,
    }
}

export default useResetMfa
